export default "__VITE_ASSET__Dba_4dut__"